// spotify-shapes.js — read Spotify playlist payloads across the Feb 2026
// Web API rename.
//
// Spotify renamed playlist contents in its February 2026 Development Mode
// changes (live for existing apps from 9 March 2026): `/playlists/{id}/tracks`
// became `/playlists/{id}/items` (the old path is 403), the playlist object's
// `tracks` paging field became `items`, and each entry's `track` became
// `item`. Checked against the live API 2026-10-31.
//
// Development Mode also serves contents only for playlists the user owns or
// collaborates on: a followed playlist's GET /playlists/{id} comes back with
// no `items` field at all, and its /items is 403. Playing it whole still
// works, because Sonos plays the spotify:playlist URI itself.

// The track (or episode) object inside one playlist entry, new or old shape.
export function entryTrack(entry) {
  if (!entry) return null;
  return entry.item || entry.track || null;
}

// Track objects from a GET /playlists/{id} (or /albums/{id}) payload.
// Albums still use `tracks.items` with bare track objects; playlists now use
// `items.items` with wrapped entries. Both, plus the pre-2026 playlist shape.
export function payloadTracks(data) {
  const entries = data?.items?.items || data?.tracks?.items || [];
  return entries.map((e) => entryTrack(e) || (e && e.id && e.name ? e : null)).filter(Boolean);
}

// True when a playlist payload carried no contents field at all, which is
// how Spotify answers for a playlist the user only follows.
export function contentsWithheld(data) {
  return !!data && !data.items && !data.tracks;
}

// Whether Development Mode will list this playlist's contents for `meId`.
export function canListItems(playlist, meId) {
  if (!playlist) return false;
  if (playlist.collaborative) return true;
  return !!meId && playlist.owner?.id === meId;
}
